import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../../utils/storeApp";
import CallAPI from "../../../../services/apiCalls";
import { Column } from "primereact/column";
import $ from "jquery";
import { Tag } from "primereact/tag";
import { useReactToPrint } from "react-to-print";
import ReportsDropdown from "../ReportsDropdown";
import { CSVLink } from "react-csv";
import SharedMsg from "../../SharedMsg";

const ListMessageForwarding = () => {
  const navigate = useNavigate();
  const { isUserLogedIn, userRole, userToken, sharedObject, SetSharedObject } =
    useUserStore((state) => ({
      isUserLogedIn: state.isUserLogedIn,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    }));
  const [userObj, setUserObj] = useState([]);
  const [count, setCount] = useState(0);
  const [refreshObj, SetRefreshObj] = useState(false);
  const [processing, SetProcessing] = useState(false);

  useEffect(() => {
    let obj = sharedObject.UserActiviySearch;
    if (obj && Object.keys(obj).length > 0) {
      setLast(obj.count < 25 ? obj.count : 25);
      gridData(obj);
    }

  }, [sharedObject.UserActiviySearch]);
  const getLastWeek = () => {
    let today = new Date();
    let lastWeek = new Date(today - 30);
    return lastWeek;
  };
  const getReport = async (src, pg) => {
    SetProcessing(true);
    let call =
      "/reports/MessageForwarding?searchPhrase=''&sortDir=SentDate&sortBy=SentDate&current=" +
      pg;
    SetRefreshObj(src);
    const res = await CallAPI(call, src, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      gridData(res.data.data);
      SetProcessing(false);
    } else {
      SetProcessing(false);
    }
  };
  const gridData = (obj) => {
    let cnt = obj.count;
    setCount(cnt);
    let tempObj = [];
    for (const row of obj.pageItems) {
      tempObj.push(row);
    }
    setUserObj(tempObj);
  };

  const formatDateAccepted = (dt) => {
    return dt.forwardingStartDate
      ? new Date(dt.forwardingStartDate).toLocaleString("en-US", {
          hour12: false,
        })
      : null;
  };
  const formatDateConfirmed = (dt) => {
    return dt.forwardingEndDate
      ? new Date(dt.forwardingEndDate).toLocaleString("en-US", {
          hour12: false,
        })
      : null;
  };

  const [first, setFirst] = useState(1);
  const [last, setLast] = useState(25);
  const [rows, setRows] = useState(25);
  const onPageChange = (event) => {
    setFirst(event.first + 1);
    setRows(event.rows);
    let lastNr = event.first + 25;
    let last = lastNr > count ? count : lastNr;
    setLast(last);
    let page = event.page + 1;
    SetRefreshObj(sharedObject.messageForwarding);
    getReport(sharedObject.messageForwarding, page);
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const refreshPage = () => {
    setFirst(1);
    setLast(25);
    getReport(sharedObject.messageForwarding, 1);
  };

  const bulkDownLoad = () => {
    SetSharedObject("UserMsgyType", "bulk");
    $("#SearchMessageForwarding").modal("show");
  };
  
  const sentMessageTemplate = (product) => {
    let s = (
      <Tag
        value={product.forwardingStatusString}
        severity={getSeverity(product)}
      ></Tag>
    );

    return s;
  };
  const getSeverity = (product) => {
    switch (product.forwardingStatusString) {
      case "Active":
        return "success";
      case "Success":
        return "success";
      case "Accepted":
        return "success";
      case "Failed":
        return "danger";
      case "Pending":
        return "warning";
      default:
        return null;
    }
  };
  const headers = [
    {
      label: "User Name",
      key: "userNameDisplay",
    },
    { label: "Account Name", key: "accountName" },
    { label: "Direct Email", key: "directEmailAddress" },
    { label: "Forwarding Email Address", key: "forwardingEmailAddress" },
    { label: "Forwarding Start Date", key: "forwardingStartDate" },
    { label: "Forwarding End Date", key: "forwardingEndDate" },
    { label: "Status", key: "forwardingStatusString" },
    { label: "Organization", key: "organizationName" },
  ];

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <main ref={componentRef} className="ListMessageForwarding">
        <header>
          <div className="spacer-inline sp-margin12">
            <h4 className="title-label3">
               Message Forwarding Activity
            </h4>
          </div>
          <div className="mid-header-bar spacer-inline sp-mx5">
            <ReportsDropdown />
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-toggle="modal"
              aria-label="Open message forwarding search"
              aria-haspopup="dialog"
              onClick={(e) => {
                SetSharedObject("UserMsgyType", "reg");
                $("#SearchMessageForwarding").modal("show");
              }}
            >
              <i className="bi bi-search" aria-hidden="true"></i>
            </button>
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              aria-label="Open bulk download message forwarding search"
              aria-haspopup="dialog"
              data-toggle="modal"
              onClick={(e) => {
                bulkDownLoad();
              }}
            >
              <i className="bi bi-box-arrow-down" aria-hidden="true"></i>
            </button>
            <div className="spacer-inline" role="toolbar" aria-label="Message forwarding report export and refresh tools">
             <span className="SharedTools" role="group" aria-label="Export and print tools">
                {count > 0 ? (
                  <CSVLink
                    filename="ListMessageForwarding.csv"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    aria-label="Download mail forwarding as MS Excel CSV file"
                    data={userObj}
                    headers={headers}
                  >
                    <i className="bi bi-download" aria-hidden="true"></i>
                  </CSVLink>
                ) : (
                  <button
                    type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled
                    aria-disabled="true"
                    aria-label="Download CSV (no results available)"
                    >
                    <i className="bi bi-download" aria-hidden="true"></i>
                  </button>
                )}

              <button
                type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled={userObj.length === 0} 
                    aria-disabled={userObj.length === 0}
                    aria-label={
                          userObj.length === 0
                            ? "Refresh report (no results to refresh)"
                            : "Refresh report"
                        }
                onClick={(e) => {
                  if (count > 0) refreshPage();
                }}
              >
                <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled={userObj.length === 0} 
                    aria-disabled={userObj.length === 0}
                    aria-label={
                      userObj.length === 0
                        ? "Print report (no results to print)"
                        : "Print received messages report"
                    }
                onClick={(e) => {
                  if (count > 0) handlePrint();
                }}
              >
                <i className="bi bi-printer" aria-hidden="true"></i>
              </button>
            </span>
            </div>
          </div>
        </header>
      <div>
        <section className="grid-header-bar" aria-label="Report filter summary">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <>
            <dl className="sp-mx7 ">
              <div className="spacer-inline spacer-margin1">
                <dt className="ft-wt">Domain:</dt>
                <dd className="sp-margin12 sp-mx7">
                  {sharedObject?.messageForwarding?.DomainName
                    ? sharedObject?.messageForwarding?.DomainName
                    : null}
                </dd>
              </div>
              <div className="spacer-inline">
                <dt className="ft-wt">Customer:</dt>
                <dd className="sp-margin12 sp-mx7">
                  {sharedObject?.messageForwarding?.VendorName
                    ? sharedObject?.messageForwarding?.VendorName
                    : null}
                </dd>
               </div>
              </dl>
            </>
          )}
          <SharedMsg />
        </section>
        <section className="grid-layout">
          {userObj?.length > 0 ? (
            <div id="SentMessageReport">
              <DataTable
                value={userObj}
                aria-label="Mail Forwarding Report"
                rows={25}
                paginator
                selectionPageOnly
                rowsPerPageOptions={[25, 50, 75]}
                tableStyle={{ minWidth: "50rem" }}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                dataKey="Id"
                columnResizeMode="expand"
                resizableColumns
                scrollable
                sortField="forwardingStartDate"
                sortOrder={-1}
              >
                <Column field="userNameDisplay" header="User Name" className="print-col" ></Column>
                <Column field="accountName" header="Account Name" className="print-col" sortable ></Column>
                <Column field="directEmailAddress" header="Direct Email" className="truncate" sortable ></Column>
                <Column field="forwardingEmailAddress" header="Forwarding Email Address" className="truncate" sortable ></Column>
                <Column field="forwardingStartDate" header="Forwarding Start Date" className="w-md8" sortable body={formatDateAccepted} ></Column>
                <Column field="forwardingEndDate" header="Forwarding End Date" className="w-md7" sortable body={formatDateConfirmed} ></Column>
                <Column field="forwardingStatusString" header="Status" className="w-md4" sortable body={sentMessageTemplate} ></Column>
                <Column field="organizationName" header="Organization" className="print-col" sortable ></Column>
              </DataTable>
            </div>
          ) : (
            <section className="empty-grid" role="status" aria-live="polite" aria-atomic="true">
              There are currently no search results.
            </section>
          )}
        </section>

        {processing && (
          <div 
            className="loader-container" 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            aria-labelledby="message-forwarding-loader"
        >
            <div className="spinner" aria-hidden="true"></div>
            <div className="loading-text" id="message-forwarding-loader">{loadingText}</div>
        </div>
        )}
      </div>
    </main>
  );
};

export default ListMessageForwarding;
